import {useCallback, useState} from 'react';
import {useLocalStorage} from '@chekinapp/ui';

const STORAGE_PREFIX = 'chekin-rail';

type RailStorageValue = 'collapsed' | 'expanded';

export type CollapsibleRailState = {
  isOpen: boolean;
  hasToggled: boolean;
  toggle: () => void;
};

function useCollapsibleRail(id: string): CollapsibleRailState {
  const [value, setValue] = useLocalStorage<RailStorageValue>(
    `${STORAGE_PREFIX}:${id}`,
    'expanded',
  );
  const [hasToggled, setHasToggled] = useState(false);

  const toggle = useCallback(() => {
    setHasToggled(true);
    setValue(previous => (previous === 'collapsed' ? 'expanded' : 'collapsed'));
  }, [setValue]);

  return {isOpen: value !== 'collapsed', hasToggled, toggle};
}

export {useCollapsibleRail};
